<template>
  <div
    :class="
      'app ' +
      (role == 'researcher'
        ? 'resBack'
        : role == 'referee'
        ? 'refBack'
        : role == 'university'
        ? 'uniBack'
        : role == 'manager'
        ? 'adminBack'
        : role == 'admin'
        ? 'adminBack'
        : '')
    "
  >
    <AppHeader fixed>
      <!-- <div
        style="width: 100%; text-align: center; background-color: red"
        class="text-light p-2"
        v-if="origin != 'https://biodcportal.com'"
      >
        شما در حال استفاده از
        <a :href="origin" target="_blank">
          نسخه آزمایشی سامانه تقسیم کار ملی
        </a>
        هستید. لطفا جهت استفاده از سامانه اصلی از
        <a
          href="https://biodcportal.com"
          target="_blank"
          rel="noopener noreferrer"
          >این آدرس</a
        >
        استفاده بفرمایید.
      </div> -->
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="dashboard">
        <img
          class="navbar-brand-full"
          src="../assets/images/biodc-small.png"
          width="89"
          height="50"
          alt="ستاد زیست فناوری ریاست جمهوری"
        />
        <img
          class="navbar-brand-minimized"
          src="../assets/images/biodc-small.png"
          width="30"
          height="30"
          alt="ستاد زیست فناوری ریاست جمهوری"
        />
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" />
      <b-navbar-nav class="ml-auto"> </b-navbar-nav>
      <div>
        <b-dropdown no-caret class="mr-2" variant=".link">
          <template v-slot:button-content>
            <i class="fa fa-user fa-2x" aria-hidden="true"></i>
          </template>
          <b-dropdown-item disabled
            ><b>نقش کاربر:</b> {{ roleName }}</b-dropdown-item
          >
          <b-dropdown-item
            v-if="
              (role == 'researcher' ||
                role == 'referee' ||
                role == 'university') &&
              user != ''
            "
            @click="push()"
            ><i class="fa fa-address-card text-dark" aria-hidden="true"></i
            >{{ user }}</b-dropdown-item
          ><b-dropdown-item-button v-if="role == 'researcher'"
            ><i
              class="fa fa-question-circle text-dark fa-flip-horizontal"
              aria-hidden="true"
            ></i
            ><b-link
              href="/researcher/guide"
              target="ـblank"
              class="black--text"
              style="text-decoration: none"
              >راهنما
            </b-link></b-dropdown-item-button
          >
          <b-dropdown-item-button v-if="role == 'admin'" @click="changePass()"
            ><i class="fa fa-lock text-dark" aria-hidden="true"></i> تغییر رمز
            عبور</b-dropdown-item-button
          >
          <b-dropdown-item-button @click="logout()"
            ><i class="fa fa-sign-out text-dark" aria-hidden="true"></i>
            خروج</b-dropdown-item-button
          >
        </b-dropdown>
      </div>
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed minimized>
        <SidebarHeader />
        <SidebarForm />
        <SidebarNav :navItems="nav" :light="true"></SidebarNav>
        <SidebarFooter />
        <SidebarMinimizer />
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list" />
        <div class="container-fluid">
          <router-view v-if="allowRender"></router-view>
          <b-card v-else>
            کنترل دسترسی... لطفا کمی صبر کنید...
            <b-spinner variant="success" type="grow"></b-spinner>
            &nbsp;
            <b-spinner variant="danger" type="grow"></b-spinner>
            &nbsp;
            <b-spinner variant="info" type="grow"></b-spinner>
          </b-card>
        </div>
      </main>
    </div>
    <TheFooter class="mt-4">
      <!--footer-->
      <div>
        <a href="/map" target="_blank">پرتال طرح تقسیم کار ملی</a>
        <span class="ml-1"
          >&copy; {{ moment(new Date()).format("jYYYY") }}</span
        >
      </div>
      <div class="ml-auto">
        <span class="mr-1">محصولی از</span>
        <a href="https://biotechmag.ir/">ستاد توسعه زیست فناوری</a>
      </div>
      <div class="ml-auto">
        <i class="fa fa-pencil" aria-hidden="true"></i> &nbsp;
        <span class="mr-1"
          >نسخه:
          <a :href="'/' + role + '/changelog'" target="_blank">
            {{ versionNum }}
          </a></span
        >
      </div>
    </TheFooter>
  </div>
</template>

<script>
import navList from "@/_nav";
import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer,
  SidebarNav,
  Aside as AppAside,
  AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
} from "@coreui/vue";
import moment from "moment-jalaali";
import router from "../router";
import { version } from "../../package.json";

import semver from "semver";
import { ThemingService } from "../services/theme.js";

export default {
  name: "DefaultContainer",
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
  },
  data() {
    return {
      nav: [],
      navList: navList,
      moment: moment,
      user: "",
      role: "",
      roleName: "",
      versionNum: "",
      minVer: 0,
      allowRender: false,
      origin: "",
      isCatComplete: false,
    };
  },
  methods: {
    push() {
      if (this.role == "researcher") {
        router.push("/researcher/profile");
      }
      if (this.role == "referee") {
        router.push("/referee/profile");
      }
      if (this.role == "company") {
        router.push("/company/profile");
      }
      if (this.role == "accelerator") {
        router.push("/accelerator/profile");
      }
      if (this.role == "university") {
        router.push("/university/dashboard");
      }
    },
    logout() {
      let noShow = JSON.parse(localStorage.getItem("noShow"));

      switch (localStorage.role) {
        case "admin":
        case "manager":
        case "companyManager":
          window.localStorage.clear();
          localStorage.setItem("noShow", noShow);
          this.$router.replace("/adminlogin");
          break;
        case "referee":
          window.localStorage.clear();
          localStorage.setItem("noShow", noShow);
          window.location.replace("/reflogin");
          break;
        case "university":
          window.localStorage.clear();
          localStorage.setItem("noShow", noShow);
          window.location.replace("/unilogin");
          break;
        case "company":
          window.localStorage.clear();
          localStorage.setItem("noShow", noShow);
          window.location.replace("/companylogin");
          break;
        case "accelerator":
          window.localStorage.clear();
          localStorage.setItem("noShow", noShow);
          window.location.replace("/acceleratorlogin");
          break;
        default:
          window.localStorage.clear();
          localStorage.setItem("noShow", noShow);
          window.location.replace("/login");
          break;
      }
    },
    changePass() {
      this.$router.push("/admin/changepassword");
    },
    changeThemeMode() {
      let themeName = this.role;
      ThemingService.changeTheme(themeName);
    },
  },
  computed: {
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  mounted() {
    this.origin = window.location.origin;
    this.versionNum = version;
    const userRole = this.$route.path.split("/")[1];

    this.$http
      .post(this.baseUrl + "/setad/authentication/minVersion")
      .then((res) => {
        this.minVer = res.data;

        if (semver.lt(version, this.minVer)) {
          const title = (
            <div>
              <h3 class="text-center">!ورژن قدیمی</h3>
              <span>
                استفاده کنید (Ctrl + F5) لطفا برای مشاهده‌ی آخرین نسخه نرم افزار
                از کلید ترکیبی
              </span>
            </div>
          );
          this.toast(title, "error");
        }
      })
      .catch((err) => {
        console.log(err);
        this.toast(err.response.data, "error");
      });

    this.user = localStorage.getItem("username");
    this.role = localStorage.getItem("role");
    this.isCatComplete = localStorage.getItem("isCatComplete");
    this.isCatComplete = this.isCatComplete == "false" ? false : true;

    var myMenu = [];
    let trustedAcceleratorExtraMenu = {
      name: "کل حمایت‌ها",
      url: "/accelerator/allRequests",
      icon: "fa fa-list",
    };

    switch (this.role) {
      case "admin":
        myMenu = this.navList.admin;
        this.roleName = "ادمین";
        break;
      case "university":
        if (this.isCatComplete) myMenu = this.navList.university;
        else myMenu = this.navList.universityNotComplete;
        this.roleName = "دانشگاه";
        break;
      case "referee":
        myMenu = this.navList.referee;
        this.roleName = "داور";
        break;
      case "manager":
        myMenu = this.navList.manager;
        this.roleName = "مدیر";
        break;
      case "head":
        myMenu = this.navList.head;
        this.roleName = "ادمین ناظر";
        break;
      case "companyManager":
        myMenu = this.navList.companyManager;
        this.roleName = "ادمین شرکت‌ها";
        break;
      case "company":
        myMenu = this.navList.company;
        this.roleName = "شرکت";
        break;
      case "accelerator":
        myMenu = JSON.parse(JSON.stringify(this.navList.accelerator));
        if (JSON.parse(localStorage.getItem("isTrusted"))) {
          myMenu.splice(8, 0, trustedAcceleratorExtraMenu);
        }
        this.roleName = "شتاب دهنده";
        break;

      default:
        myMenu = this.navList.researcher;
        this.roleName = "پژوهشگر";
        break;
    }

    this.nav = myMenu;

    if (this.role != "company" && this.role != "accelerator") {
      this.$http
        .post(
          this.baseUrl +
            "/setad/" +
            userRole +
            (userRole == "head" ? "/user" : "") +
            (userRole == "companyManager" ? "/user" : "") +
            "/checkToken",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          if (res.status == 200) {
            this.allowRender = true;
            if (userRole == "university")
              localStorage.setItem(
                "isCatComplete",
                res.data.isCatComplete ? res.data.isCatComplete : false
              );
            this.changeThemeMode();
          }
        })
        .catch((err) => {
          if (err.response.status == 403 || err.response.status == 404) {
            const title = (
              <div>
                <h3 class="text-center">دسترسی منقضی شده است</h3>
                <span>
                  لطفا جهت استفاده از سامانه، با توجه به نقش خودتان، ورود کنید.
                </span>
              </div>
            );
            this.toast(title, "error");
            this.$router.push({
              path:
                this.role == "researcher"
                  ? "/login"
                  : this.role == "referee"
                  ? "/reflogin"
                  : this.role == "university"
                  ? "/unilogin"
                  : this.role == "manager"
                  ? "/adminlogin"
                  : this.role == "head"
                  ? "/adminlogin"
                  : this.role == "admin"
                  ? "/adminlogin"
                  : this.role == "companyManager"
                  ? "/adminlogin"
                  : this.role == "company"
                  ? "/companylogin"
                  : this.role == "accelerator"
                  ? "/acceleratorlogin"
                  : "",
              query: { return: window.location.pathname },
            });
          }
        });
    } else {
      this.allowRender = true;
      this.changeThemeMode();
    }
  },
};
</script>
<style scoped>
.colored {
  background-color: blue;
}

.resBack {
  background-image: url("../assets/images/resBack.png");

  background-size: cover;
}
.refBack {
  background-image: url("../assets/images/refBack.png");

  background-size: cover;
}

.headBack {
  background-image: url("../assets/images/uniBack.png");

  background-size: cover;
}
.adminBack {
  background-image: url("../assets/images/adminBack.png");

  background-size: cover;
}
</style>
